module.exports = __webpack_public_path__ + "static/media/helpdesk-icon.5726602f.png";